module.exports = __webpack_public_path__ + "static/media/Freemason_s Hall.3324d337.jpg";